import React, { useState, useEffect } from "react";
import { Plane } from "lucide-react";

const ScrollJourney = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight;
      const scrollTop = window.scrollY - heroHeight;
      const docHeight = document.body.scrollHeight - window.innerHeight - heroHeight;
      if (scrollTop < 0) { setScrollProgress(0); return; }
      setScrollProgress(Math.min(scrollTop / docHeight, 1));
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (scrollProgress <= 0) return null;

  const pathLength = 3000;
  const dashOffset = pathLength - (pathLength * scrollProgress);
  const planeY = 20 + scrollProgress * 2960;
  const planeWobble = Math.sin(scrollProgress * 40) * 14;

  return (
    <div className="fixed left-4 lg:left-10 top-0 bottom-0 z-30 pointer-events-none hidden lg:block" style={{ opacity: Math.min(scrollProgress * 4, 0.8) }}>
      <svg width="80" height="100%" viewBox="0 0 80 3000" preserveAspectRatio="xMidYMid meet" className="h-full">
        <path
          d={`M 40 20 Q 56 200 40 400 Q 24 600 40 800 Q 56 1000 40 1200 Q 24 1400 40 1600 Q 56 1800 40 2000 Q 24 2200 40 2400 Q 56 2600 40 2800 L 40 3000`}
          fill="none"
          stroke="#C4956A"
          strokeWidth="2.5"
          strokeDasharray="12 8"
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          className="transition-none"
        />
        {[400, 1000, 1600, 2200, 2800].map((y, i) => (
          <circle
            key={i}
            cx="40"
            cy={y}
            r={scrollProgress * pathLength > y ? 7 : 3.5}
            fill={scrollProgress * pathLength > y ? "#C4956A" : "transparent"}
            stroke="#C4956A"
            strokeWidth="1.5"
            className="transition-all duration-300"
          />
        ))}
      </svg>
      <div
        className="absolute transition-none"
        style={{
          left: `${20 + planeWobble}px`,
          top: `${(planeY / 3000) * 100}%`,
          transform: "rotate(135deg)",
        }}
      >
        <Plane size={32} className="text-[#C4956A] fill-[#C4956A]/30" />
      </div>
    </div>
  );
};

export default ScrollJourney;
